import { Alert, Button, Stack } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useNovidades } from '../../contexts/NovidadesContext';
import { toastErro } from '../../utils/toast';

export default function AvisoNovidades() {
    const { dados, salvando, marcarLida } = useNovidades();
    const { pathname } = useLocation();
    if (!dados?.naoLida || pathname === '/novidades') return null;
    return (
        <Alert severity="info" sx={{ mb: 2 }} action={
            <Stack direction="row" spacing={1}>
                <Button component={Link} to="/novidades" color="inherit" size="small">Ver novidades</Button>
                <Button color="inherit" size="small" disabled={salvando}
                    onClick={() => marcarLida().catch(() => toastErro('Não foi possível guardar a leitura. Tente novamente.'))}>
                    Dispensar
                </Button>
            </Stack>
        }>
            O Pátio foi atualizado. Confira as novidades desta versão.
        </Alert>
    );
}
